<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <!-- Create Product Button -->
      <div style="float: right; margin-bottom: 10px;">
        <md-button class="md-success" @click="$router.push({ path: 'create-product'})">
          Create Product
        </md-button>
      </div>

      <!-- Search Section -->
      <md-card style="margin-bottom: 20px;">
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Product Name</label>
                <md-input v-model="search.name" placeholder="Enter product name" />
              </md-field>
            </div>
            <div class="md-layout-item md-size-25">
              <md-checkbox v-model="search.best" :true-value="true" :false-value="false">
                Best Product
              </md-checkbox>
            </div>
            <div class="md-layout-item md-size-25" style="display: flex; align-items: center;">
              <md-button class="md-primary" @click="performSearch">Search</md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>

      <!-- Product Table -->
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>shopping_bag</md-icon>
          </div>
          <h4 class="title">Product List</h4>
        </md-card-header>

        <md-card-content v-if="tableData.length == 0">
          <h4>No data found.</h4>
        </md-card-content>

        <md-card-content v-else>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="md-container-custom paginated-table"
            table-header-color="green"
            md-fixed-header
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Banner Image">
                <img
                  :src="item.mainImageUrl"
                  alt="Product Image"
                  style="width: 100px; height: auto; object-fit: cover; border-radius: 4px;"
                />
              </md-table-cell>

              <md-table-cell md-label="Title" md-sort-by="title">{{ item.name }}</md-table-cell>
              <md-table-cell md-label="Price" md-sort-by="price">{{ item.price }}</md-table-cell>
              <md-table-cell md-label="Offer Price" md-sort-by="offerPrice">{{ item.offerPrice }}</md-table-cell>
              <md-table-cell md-label="Created On" md-sort-by="created_at">
                {{ HumanReadableDateFormat(item.created_at, true) }}
              </md-table-cell>

              <!-- Best Product Checkbox -->
              <md-table-cell md-label="Best Product">
                <md-checkbox
                  v-model="item.bestProduct"
                  @change="toggleBestProduct(item._id, item.bestProduct)"
                >
                </md-checkbox>
              </md-table-cell>

              <md-table-cell md-label="Actions">
                <md-button
                  class="md-just-icon md-info md-simple pr-5"
                  @click="$router.push({ path: 'product-images', query: { id: item._id }})"
                  title="Product Images"
                >
                  <md-icon>photo_library</md-icon>
                </md-button>

                <md-button
                  class="md-just-icon md-primary md-simple pr-5"
                  @click="$router.push({ path: 'update-product/' + item._id })"
                  title="Edit Product"
                >
                  <md-icon>edit</md-icon>
                </md-button>

                <md-button
                  class="md-just-icon md-danger md-simple"
                  title="Delete Product"
                  @click="deleteProduct(item._id)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>

          <md-card-actions md-alignment="space-between">
            <div>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </pagination>
          </md-card-actions>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import { Pagination } from "@/components";
import ProductService from "../../../services/ProductService";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tableData: [],
      searchedData: [],
      search: {
        name: "",
        best: null, // null = ignore, true/false = filter
      },
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
      },
      currentSort: "created_at",
      currentSortOrder: "asc",
    };
  },
  computed: {
    queriedData() {
      const data = this.searchedData.length ? this.searchedData : this.tableData;
      return data.slice(this.from, this.to);
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    to() {
      let high = this.from + this.pagination.perPage;
      return high > this.total ? this.total : high;
    },
    total() {
      return this.searchedData.length ? this.searchedData.length : this.tableData.length;
    },
  },
  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const key = this.currentSort;
        if (this.currentSortOrder === "desc") return a[key].localeCompare(b[key]);
        return b[key].localeCompare(a[key]);
      });
    },

    getProducts() {
      ProductService.getProducts()
        .then((response) => {
          this.tableData = response.data.data;
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },

    deleteProduct(id) {
      Swal.fire({
        title: "Are you sure?",
        text: `Product data will be deleted.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, Delete It!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          ProductService.deleteProduct({ id })
            .then((response) => {
              this.$toast.success(response.data.response_msg);
              this.getProducts();
            })
            .catch((e) => {
              this.$toast.error(e.response.data.respones_msg);
            });
        }
      });
    },

    // Called when Best Product checkbox is toggled
    toggleBestProduct(id, value) {
      ProductService.updateBestProduct({ id, bestProduct: value })
        .then((res) => {
          this.$toast.success("Best Product updated successfully");
        })
        .catch((err) => {
          this.$toast.error("Failed to update Best Product");
        });
    },

    performSearch() {
      this.searchedData = this.tableData.filter((item) => {
        const name = (item.name || "").toString().trim().toLowerCase();
        const searchName = (this.search.name || "").toLowerCase().trim();
        const matchName = name.includes(searchName);

        // If search.best is null or undefined, ignore it
        const matchBest =
          this.search.best === null || this.search.best === undefined
            ? true
            : (item.bestProduct || false) === this.search.best;

        return matchName && matchBest;
      });

      this.pagination.currentPage = 1; // reset to first page
    }
  },
  beforeMount() {
    this.getProducts();
  },
};
</script>